import Keycloak from 'keycloak-js';


console.log(process.env.NODE_ENV)

const options = {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    clientId: process.env.REACT_APP_CLIENT_ID,
    realm: process.env.REACT_APP_REALM
}

const keycloak = new Keycloak(options);
let authenticated;
let store = null;

/**
 * Initializes Keycloak, then run callback. This will prompt you to login.
 *
 * @param onAuthenticatedCallback
 */
async function init(onInitCallback) {
    try {
        authenticated = await keycloak.init({ onLoad: "login-required" });

        const userInfo = await keycloak.loadUserInfo().then(user => { return user }).catch(e => console.log(e));
        const user = {
            authenticated: keycloak.authenticated,
            username: keycloak.idTokenParsed.preferred_username,
            token: keycloak.token,
            refreshToken: keycloak.refreshToken,
            email: userInfo ? userInfo.email : undefined,
            name: userInfo ? userInfo.name : undefined,
            fullName: userInfo ? userInfo.name : undefined,
            id: userInfo ? userInfo.id : undefined,
            roles: keycloak.resourceAccess.account.roles
        }
        localStorage.setItem("authUser", JSON.stringify(user))
        return onInitCallback
    } catch (error) {
        console.error("Keycloak init failed")
        console.error(error)
    }
};

/**
 * Initializes store with Keycloak user data
 *
 */
async function initStore(storeInstance) {
    try {
        store = storeInstance
        store.initOauth(keycloak, false)
        // Show alert if user is not authenticated
        if (!authenticated) { alert("not authenticated") }
    } catch (error) {
        console.error("Keycloak init failed")
        console.error(error)
    }
};

/**
 * Logout user
 */
function logout(url) {
    keycloak.logout({ redirectUri: url });
}

/**
 * Refreshes token
 */
async function refreshToken() {
    try {
        await keycloak.updateToken(480);
        return keycloak;
    } catch (error) {
        console.error('Failed to refresh token');
        console.error(error);
    }
}

const KeycloakService = {
    CallInit: init,
    CallInitStore: initStore,
    CallLogout: logout,
    CallTokenRefresh: refreshToken
};

export default KeycloakService;